import { createContext } from 'react';

export const PersonalizedInviteContext = createContext();
